var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import PageHeader from "../../components/PageHeader";
import SearchBar from "../../components/SearchBar";
import UserListSingle from "../../components/UserListSingle";
import FilterModal from "../../components/modals/FilterModal";
import icons from "../../utils/Icons";
import PrimaryButton from "../../components/Button/PrimaryButton";
import { useDispatch, useSelector } from "react-redux";
import { clearFilter, removeSelectedPosition, setStatusId } from "../../store/slices/filterSlice";
import useFetchUserList from "../../hooks/useFetchUserList";
import useFetchStatuses from "../../hooks/useFetchStatuses";
import Spinner from "../../components/Spinner";
import useFilterUserList from "../../hooks/useFilterUserList";
import useChaseListNavigate from "../../hooks/useChaseListNavigate";
var Search = function () {
    var _a;
    var _b = useState(false), showFilter = _b[0], setShowFilterModal = _b[1];
    var dispatch = useDispatch();
    var filter = useSelector(function (state) { return state.filter; });
    var selectedPositions = filter.selectedPositions;
    var userList = useSelector(function (state) { return state.userList.list; });
    var statuses = useSelector(function (state) { return state.statuses.statuses; });
    var loadingUserList = useSelector(function (state) { return state.userList.loading; });
    var filteredUserList = useFilterUserList(userList, filter.statusId, filter.selectedPositions, filter.name);
    var userMappedList = filteredUserList ? filteredUserList.map(function (item) {
        var seniority = item.seniority;
        var seniority_show = '';
        if (seniority < 1) {
            switch (seniority) {
                case -3:
                    seniority_show = 'SS';
                    break;
                case -2:
                    seniority_show = "CAS";
                    break;
                default:
                    seniority_show = "JRY";
                    break;
            }
        }
        else {
            if (seniority >= 1 && seniority <= 5)
                seniority_show = "".concat(seniority, " \u2022 U");
            if (seniority >= 6 && seniority <= 10)
                seniority_show = "".concat(seniority, " \u2022 C");
            if (seniority >= 11 && seniority <= 15)
                seniority_show = "".concat(seniority, " \u2022 B");
            if (seniority >= 16 && seniority <= 20)
                seniority_show = "".concat(seniority, " \u2022 A");
            if (seniority >= 21 && seniority <= 25)
                seniority_show = "".concat(seniority, " \u2022 AA");
            if (seniority >= 26)
                seniority_show = "".concat(seniority, " \u2022 AAA");
        }
        // const seniority_show = item.seniority + " • " + item.language;
        return {
            name: item.name,
            date: item.date,
            experience: seniority_show,
            status: statuses[item.deleted],
            positions: item.position,
            image: item.imgUrl,
            union_member: item.union_member,
            id: item.id,
            updated_at: item.updated_at,
        };
    }) : [];
    var fetchUserListData = useFetchUserList().fetchUserListData;
    var fetchDataStatusesData = useFetchStatuses().fetchDataStatusesData;
    useEffect(function () {
        fetchUserListData();
        fetchDataStatusesData();
    }, []);
    var openFilterModalHandle = function () {
        setShowFilterModal(true);
    };
    var closeFilterModalHandle = function () {
        setShowFilterModal(false);
    };
    var applyFilters = function () {
        console.log("applying filters...");
    };
    var chaseListNavigate = useChaseListNavigate();
    var BackHandle = function () {
        chaseListNavigate("#/home");
    };
    return (_jsxs("div", { children: [_jsx(PageHeader, { pageTitle: "Search", backTitle: "Home", backAction: BackHandle }), _jsxs("div", { className: "flex-1 overflow-y-auto custom-content-height px-[18px] py-[18px] bg-[#F7F7F7]", children: [_jsx("div", { className: " lg:flex lg:justify-end", children: _jsxs("div", { className: "lg:w-[40%]", children: [_jsxs("div", { className: "flex items-center justify-between w-full", children: [_jsx(SearchBar, {}), _jsx("button", { onClick: function () { return openFilterModalHandle(); }, className: "bg-white shadow-button-inner flex items-center justify-center rounded-[10px] p-2 h-[44px] border w-[50px] border-[#EAEAEC]", children: _jsx("img", { className: "", src: icons.filter, alt: "" }) })] }), selectedPositions.length > 0 &&
                                    _jsx("div", { className: "my-[12px] flex items-center justify-between", children: _jsxs("div", { className: "flex items-center", children: [_jsx("span", { className: "text-[14px] font-inter", children: "Positions:" }), _jsxs("div", { className: "relative px-2  lg:w-[80%]", children: [_jsx("div", { className: "overflow-x-scroll lg:overflow-hidden flex gap-2 item-center w-[240px] lg:w-[100%] px-3", children: selectedPositions.map(function (position, index) { return (_jsx(PrimaryButton, { title: position, classes: "bg-[#FFFFFF] text-nowrap border-[#2F2B431A] shadow-button-inner text-[#ADADAD] py-1 px-3 text-xs", icon: icons.closeGray, iconPosition: "right", clickHandle: function () {
                                                                    return dispatch(removeSelectedPosition(position));
                                                                } }, index)); }) }), _jsx("div", { style: {
                                                                background: "linear-gradient(to right, rgba(247, 247, 247, 0), rgba(247, 247, 247, 1))",
                                                            }, className: "lg:hidden absolute right-0 top-0 w-[50px] h-[24px]" })] })] }) }), filter.statusId !== undefined &&
                                    _jsx("div", { className: "my-[12px] flex items-center justify-between", children: _jsxs("div", { className: "flex items-center", children: [_jsx("span", { className: "text-[14px] font-inter", children: "Status:" }), _jsxs("div", { className: "relative px-2  lg:w-[80%]", children: [_jsx("div", { className: "overflow-x-scroll lg:overflow-hidden flex gap-2 item-center w-[240px] lg:w-[100%] px-3", children: _jsx(PrimaryButton
                                                            // key={index}
                                                            , { 
                                                                // key={index}
                                                                title: statuses[(_a = filter.statusId) !== null && _a !== void 0 ? _a : 0], classes: "bg-[#FFFFFF] text-nowrap border-[#2F2B431A] shadow-button-inner text-[#ADADAD] py-1 px-3 text-xs", icon: icons.closeGray, iconPosition: "right", clickHandle: function () {
                                                                    return dispatch(setStatusId(undefined));
                                                                } }) }), _jsx("div", { style: {
                                                                background: "linear-gradient(to right, rgba(247, 247, 247, 0), rgba(247, 247, 247, 1))",
                                                            }, className: "lg:hidden absolute right-0 top-0 w-[50px] h-[24px]" })] })] }) }), ((filter.name !== undefined &&
                                    filter.name !== '') ||
                                    (filter.selectedPositions.length > 0) ||
                                    (filter.statusId !== undefined)) &&
                                    _jsx("div", { className: "my-[12px] flex items-center justify-between", children: _jsx("div", { children: _jsx("button", { className: "text-[#5898FD] text-nowrap text-[14px] font-inter underline", onClick: function () {
                                                    dispatch(clearFilter());
                                                }, children: "Clear Filters" }) }) })] }) }), !loadingUserList && _jsx("div", { className: "mt-4 lg:flex lg:flex-wrap lg:gap-3", children: userMappedList.map(function (item, index) { return (_jsx(UserListSingle, __assign({}, item), index)); }) }), loadingUserList &&
                        _jsx("div", { className: "flex justify-center items-center h-[300px]", children: _jsx(Spinner, { size: 160 }) }), showFilter && (_jsx(FilterModal, { closeModal: function () { return closeFilterModalHandle(); }, applyFilterHandle: applyFilters }))] })] }));
};
export default Search;
